import TagManager from 'react-gtm-module'
import Routes from 'routes'
import Header from 'components/header'
import { SessionProvider } from 'contexts/session-context'
import { LoaderContext } from 'contexts/loader-context'
import TriviaProvider from 'contexts/trivia-context'
import useWhiteBg from 'hooks/use-white-bg'
import { useAgegateConfig } from 'hooks/use-agegate'
import { useContext } from 'react'
import LoadingScreen from 'components/loading-screen'
import { Main } from './theme/theme'
import ComingSoon from './components/coming-soon'

// import { session } from 'ho'

const tagManagerArgs = {
  gtmId: `${GTM_ID}`
}

TagManager.initialize(tagManagerArgs)

function App() {
  const { load, head } = useContext(LoaderContext)
  const shouldUseWhiteBg = useWhiteBg()
  useAgegateConfig()

 

  return (
    <SessionProvider>
      <TriviaProvider>
        <Main
          shouldUseWhiteBg={shouldUseWhiteBg}
          className='min-h-view select-none flex flex-col items-center'
          style={{ backgroundImage: !shouldUseWhiteBg && `url(${AZURE_BASE_URL}/textura.svg)` }}
        >
          <ComingSoon>
            {load && <LoadingScreen />}
            {head && <Header />}
            <div
              className={`w-full flex-1 flex justify-center sm:max-w-sm z-1`}
            >
              <Routes />
            </div>
          </ComingSoon>
        </Main>
      </TriviaProvider>
    </SessionProvider>
  )
}

export default App
